import { __decorate } from "tslib";
import Vue from 'vue';
import Commponent from 'vue-class-component';
import Paint from '@blade/common/components/paint/src/index.vue';
import { getFixTool, postFixTool } from '@blade-sxp/monitor/api/record';
import { reatToPolygon } from '@blade/common/components/paint/src/utils/polygon';
import { Prop } from 'vue-property-decorator';
// eslint-disable-next-line no-use-before-define
let AlarmRepair = class AlarmRepair extends Vue {
    showStatus; // 父组件提示是否打开修复工具
    show = false; // 内部控制是否打开修复工具
    deviceId;
    type = 'rect';
    minGraphSize = { width: 150, height: 150 };
    selectGraph; // vue不能监听新增属性
    selectGraphId = '';
    drawStatus = true;
    status = false;
    style = { width: 607, height: 350 };
    options = {
        normal: {
            fillStyle: '#6DD400',
            globalAlpha: 0.5,
            lineWidth: 2,
            strokeStyle: '#6DD400',
        },
    };
    // 已经执行过保存或初始图集
    atlas = [];
    limits;
    isAtlasChange = false;
    onShowStatusChange(showStatus) {
        this.showStatus = showStatus;
        this.show = showStatus;
        this.getHistory();
    }
    onFinish(atlas, graph) {
        this.isAtlasChange = true;
        if (!this.check(atlas)) {
            this.$message.warning(this.$t('exceedLimit').toString());
            return void this.deleteGraph(graph.id);
        }
    }
    onUpdate(atlas) {
        this.clearSelect();
    }
    onMessage(message) {
        const msg = message.code === '100' ? this.$t('concaveError').toString() : message.msg;
        this.$message({ type: message.type, message: msg });
    }
    onHover(graph) {
        // console.log('onHover:', graph);
    }
    onSelect(graph) {
        if (!graph)
            return;
        this.drawStatus = false;
        const [start, end] = graph.outsideRect || [];
        if (!start || !end)
            return;
        const margin = 8;
        let width = Math.abs(end.x - start.x) + 2 * margin;
        let height = Math.abs(end.y - start.y) + 2 * margin;
        let offestX = start.x - margin;
        let offestY = start.y - margin;
        // 做适配
        if (width < this.minGraphSize.width) {
            const dis = this.minGraphSize.width - width;
            offestX -= dis / 2;
            width = this.minGraphSize.width;
        }
        if (height < this.minGraphSize.height) {
            const dis = this.minGraphSize.height - height;
            offestY -= dis / 2;
            height = this.minGraphSize.height;
        }
        // 浅拷贝防止对原graph的修改
        this.selectGraph = { ...graph, width, height, offestX, offestY };
        this.selectGraphId = graph.id;
        // console.log('onSelect:', graph);
    }
    cancelSelect() {
        this.clearSelect();
    }
    clearSelect() {
        this.drawStatus = true;
        this.selectGraph = undefined;
        this.selectGraphId = '';
    }
    handleType(type) {
        this.clearSelect();
        this.type = type;
    }
    handleClear() {
        this.clearSelect();
        this.atlas = [];
        this.isAtlasChange = true;
    }
    handleSave() {
        this.clearSelect();
        const paint = this.$refs.paint;
        paint.save();
    }
    relative(atlas) {
        const paint = this.$refs.paint;
        return paint.convert(atlas, false);
    }
    abs(atlas) {
        const paint = this.$refs.paint;
        return paint.convert(atlas);
    }
    handleDeleteGraph() {
        if (!this.selectGraphId)
            return;
        this.deleteGraph(this.selectGraphId);
        this.isAtlasChange = true;
    }
    deleteGraph(graphId) {
        const paint = this.$refs.paint;
        paint.deleteGraph(graphId);
    }
    check(atlas, isEnd = true) {
        if (!this.limits)
            return true;
        const count = this.limits[this.type];
        const total = this.limits.total;
        if (count !== undefined) {
            const typedAtlas = atlas.filter((graph) => graph.type === this.type);
            if (typedAtlas.length >= (isEnd ? count + 1 : count))
                return false;
        }
        if (total !== undefined && atlas.length >= (isEnd ? total + 1 : total))
            return false;
        return true;
    }
    getHistory() {
        if (!this.deviceId || !this.show)
            return;
        getFixTool(this.deviceId).then((res) => {
            if (res.data.data) {
                const dataSource = JSON.parse(res.data.data.allDrawer || '[]');
                this.atlas = this.relative(dataSource) || [];
                console.log(this.atlas, 9999);
            }
        });
    }
    handleMaskMouseUp() {
        this.$elmessage({ message: this.$t('notInRepairMode').toString(), type: 'warning' });
    }
    handleRepair() {
        this.status = true;
    }
    handleToolSave() {
        if (!this.status) {
            this.$elmessage({ message: this.$t('notInRepairMode').toString(), type: 'warning' });
            return;
        }
        this.handleSave();
        this.status = false;
        if (!this.isAtlasChange)
            return;
        const atlas = this.abs(this.atlas);
        const vertices = atlas.map((graph) => ({ vertices: reatToPolygon(graph.vertices) }));
        const ignorInfo = {
            allDrawer: JSON.stringify(atlas) || '[]',
            ignorRois: vertices,
        };
        postFixTool(this.deviceId, ignorInfo)
            .then((res) => {
            this.isAtlasChange = false;
            this.$elmessage({ message: this.$t('common.toolSuccess').toString(), type: 'success' });
        })
            .catch((err) => {
            this.$elmessage({ message: err, type: 'error' });
        });
    }
    handleClose() {
        if (this.isAtlasChange) {
            this.$elmessage({ message: this.$t('notSave').toString(), type: 'warning' });
        }
        this.show = false;
        this.status = false;
        this.clearSelect();
        const paint = this.$refs.paint;
        paint.close();
        this.$emit('alarmRepairClose');
    }
    onPaintMounted() {
        this.show = this.showStatus;
    }
};
__decorate([
    Prop()
], AlarmRepair.prototype, "showStatus", void 0);
__decorate([
    Prop()
], AlarmRepair.prototype, "deviceId", void 0);
AlarmRepair = __decorate([
    Commponent({
        name: 'VideoDrawer',
        components: {
            Paint,
        },
        watch: {
            showStatus(value) {
                this.onShowStatusChange(value);
            },
        },
        i18n: {
            messages: {
                'en-us': {
                    exceedLimit: 'draw to many items',
                    selectDirection: 'please select the direction',
                    concaveError: 'No concave polygons',
                    notSave: 'Error detection area information is not submitted',
                    notInRepairMode: 'Please select the wrench icon in the upper left corner before repairing',
                },
                zh: {
                    exceedLimit: '绘制的图形数量超出限制',
                    selectDirection: '请选择正方向',
                    concaveError: '不支持凹多边形',
                    notSave: '未提交误检区域信息',
                    notInRepairMode: '请先选中左上角扳手图标，再进行修复',
                },
            },
        },
    })
], AlarmRepair);
export default AlarmRepair;
